import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.795 27.587c2.738 0 5.416-.812 7.686-2.346l7.978 7.98a2.66 2.66 0 1 0 3.762-3.764l-7.977-7.98c4.241-6.325 2.557-14.894-3.77-19.138C15.15-1.904 6.584-.215 2.339 6.11c-4.242 6.325-2.554 14.895 3.77 19.138a13.8 13.8 0 0 0 7.686 2.339m0-24.401c5.855 0 10.602 4.75 10.602 10.606S19.65 24.398 13.795 24.398 3.192 19.648 3.192 13.792C3.2 7.939 7.94 3.193 13.795 3.186"
    }, null, -1)
  ]))]))
}
export default { render: render }